import React, { useCallback, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route, Redirect,
} from 'react-router-dom';
import GlobalStyle from './App.style';
import ScrollToTop, { scrollToTop } from './ScrollToTop';
import IndexPage from './components/IndexPage/IndexPage';
import AboutPage from './components/AboutPage/AboutPage';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Contact from './components/IndexPage/Contact/Contact';
import { useMobile } from './components/queries';
import ResponsiveNavBar from './components/ResponsiveNavBar/ResponsiveNavBar';

function App() {
  const [openNav, setOpenNav] = useState(false);
  const isMobile = useMobile();
  const starsRef = React.useRef();
  const scrollToStars = useCallback(() => starsRef.current && starsRef.current.scrollIntoView({ behavior: 'smooth' }), [starsRef.current]);
  const videosRef = React.useRef();
  const scrollToVideos = useCallback(() => videosRef.current && videosRef.current.scrollIntoView({ behavior: 'smooth' }), [videosRef.current]);

  const handleNavBar = (scroll = false) => () => {
    setOpenNav(!openNav);
    if (scroll) {
      scrollToTop(false)();
    }
  };
  return (
    <Router>
      <div>
        {/* <ScrollToTopController /> */}
        <GlobalStyle />
        <ResponsiveNavBar navbarState={openNav} handleNavbar={handleNavBar} />
        <Switch>
          <Route exact path="/">
            <IndexPage
              videosRef={videosRef}
              scrollToVideos={scrollToVideos}
              starsRef={starsRef}
              scrollToStars={scrollToStars}
            />
          </Route>
          <Route exact path="/about">
            <AboutPage />
          </Route>
          <Route exact path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Redirect to="/" />
        </Switch>
        <Contact />
        {!isMobile && <ScrollToTop />}
      </div>
    </Router>
  );
}

export default App;
